import { render, staticRenderFns } from "./main-reference.vue?vue&type=template&id=c9a8121c&"
import script from "./main-reference.vue?vue&type=script&lang=js&"
export * from "./main-reference.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports